import BasketPrice from "../../../entities/manhattan/basket/BasketPrice";
import { IBasketOrderPrice } from "../../../entities/manhattan/order/types";
import { IManhattanFactory } from "../types";

export const BasketPriceFactory: IManhattanFactory = class BasketPriceFactory {

  static create(basketPrice: IBasketOrderPrice, quantity: number) {
    return new BasketPrice(
      Number(basketPrice.amount) * quantity,
      basketPrice.installments,
      basketPrice.discounts,
      basketPrice.grace,
      basketPrice.participation
    );
  }

};
